import { render, staticRenderFns } from "./FinanceWorkspace.vue?vue&type=template&id=8062f5c0&scoped=true"
import script from "./FinanceWorkspace.vue?vue&type=script&lang=js"
export * from "./FinanceWorkspace.vue?vue&type=script&lang=js"
import style0 from "./FinanceWorkspace.vue?vue&type=style&index=0&id=8062f5c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8062f5c0",
  null
  
)

export default component.exports